export const TRANSLATIONS_KN = {
  login: {
    welcome: "ಸ್ವಾಗತ",
    username: "ಬಳಕೆದಾರ ಹೆಸರು",
    password: "ಗುಪ್ತಪದ",
    usernamePlaceholder: "ನೋಂದಾಯಿತ ಇಮೇಲ್ / ಬಳಕೆದಾರಹೆಸರು",
    signIn: "ಸೈನ್ ಇನ್ ಮಾಡಿ",
    forgotPassword: "ಪಾಸ್ವರ್ಡ್ ಮರೆತಿರಾ",
    noAccount: "ಖಾತೆ ಇಲ್ಲವೇ?",
    registerNow: "ಈಗ ನೋಂದಣಿ ಮಾಡಿ",
    noUsername: "ದಯವಿಟ್ಟು ನಿಮ್ಮ ಬಳಕೆದಾರ ಹೆಸರನ್ನು ನಮೂದಿಸಿ!",
    noPassword: "ದಯವಿಟ್ಟು ನಿಮ್ಮ ಗುಪ್ತಪದವನ್ನು ನಮೂದಿಸಿ!",
  },
  register: {
    newUser: "ಹೊಸ ಬಳಕೆದಾರ",
    registerHere: "ಇಲ್ಲಿ ನೋಂದಾಯಿಸಿ",
    email: "ಇಮೇಲ್",
    emailPlaceholder: "ನಿಮ್ಮ ನೋಂದಾಯಿತ ಇಮೇಲ್ ಅನ್ನು ನಮೂದಿಸಿ",
    mobileNo: "ಮೊಬೈಲ್ ನಂ",
    createPassword: "ಪಾಸ್ವರ್ಡ್ ರಚಿಸಿ",
    confirmPassword: "ಪಾಸ್ವರ್ಡ್ ದೃಢೀಕರಿಸಿ",
    passwordAgain: "ಪಾಸ್ವರ್ಡ್ ಅನ್ನು ಮತ್ತೆ ಟೈಪ್ ಮಾಡಿ",
    mobilePlease: "ದಯವಿಟ್ಟು ಮೊಬೈಲ್ ಸಂಖ್ಯೆ",
    signUp: "ಸೈನ್ ಅಪ್ ಮಾಡಿ",
    alreadyHaveAccount: "ಈಗಾಗಲೇ ಖಾತೆ ಹೊಂದಿದ್ದೀರ!",
    signIn: "ಸೈನ್ ಇನ್ ಮಾಡಿ",
    noMobileNo: "ದಯವಿಟ್ಟು ನಿಮ್ಮ ಮೊಬೈಲ್ ಸಂಖ್ಯೆಯನ್ನು ನಮೂದಿಸಿ!",
    noEmail: "ದಯವಿಟ್ಟು ನಿಮ್ಮ ಇಮೇಲ್ ಅನ್ನು ನಮೂದಿಸಿ!",
    noPassword: "ದಯವಿಟ್ಟು ನಿಮ್ಮ ಗುಪ್ತಪದವನ್ನು ನಮೂದಿಸಿ!",
    noConfirmPassword: "ದಯವಿಟ್ಟು ನಿಮ್ಮ ದೃಢೀಕರಣ ಗುಪ್ತಪದವನ್ನು ನಮೂದಿಸಿ!",
  },
  verify: {
    title: "OTP ಯೊಂದಿಗೆ ಪರಿಶೀಲಿಸಿ",
    otpOn: "ನಾವು OTP ಅನ್ನು ಕಳುಹಿಸಿದ್ದೇವೆ",
    registeredEmail: "ಮತ್ತು ನಿಮ್ಮ ನೋಂದಾಯಿತ ಇಮೇಲ್ ವಿಳಾಸ",
    codeNotReceived: "ನಾನು ಕೋಡ್ ಅನ್ನು ಸ್ವೀಕರಿಸಲಿಲ್ಲ.",
    resend: "ಮರುಕಳುಹಿಸಿ",
    itOr: "ಇದು ಅಥವಾ",
    details: "ವಿವರಗಳು",
    changeRegistrationDetails: "ನೋಂದಣಿ ವಿವರಗಳನ್ನು ಬದಲಾಯಿಸಿ",
    verify: "ಪರಿಶೀಲಿಸಿ",
  },
};
